import axios from "axios";

export default {
  async mounted(el, binding, vnode) {
    const store = vnode.ctx?.appContext?.config?.globalProperties?.$store;

    if (!store) {
      console.error("Vuex store is not available in the directive context.");
      return;
    }
    const user = await store._state?.data?.user;
     let  permissions ;
    const userdetails = await store._state?.data?.user;
    console.log("thisisdflskjdfslkdfjsldk", userdetails.userdetails);
    if (userdetails.userdetails.role === "director" || userdetails.userdetails.role === "Admin") {
      const url = `${process.env.VUE_APP_BASE_URL}companyPermissions/get_company_permission_profile`;

      try {
        const response = await axios.get(url, {
          withCredentials: true,
        });
        permissions=response.data.permissions

        console.log("thisiddirectordetailsd", response);
      } catch (error) {
        console.log(error);
      }
    }
    else{
          permissions = await user?.userPermissions;
    }

    


    // Check if permissions is a valid array
    if (!Array.isArray(permissions)) {
      console.warn("userPermissions is not an array:", permissions);
      el.style.display = "none"; // Or choose to do nothing
      return;
    }

    const loggedInUser = user?.userdetails;

    console.log("👉 Directive User:", loggedInUser);

    if (
      loggedInUser?.role === "Super Admin" ||
      loggedInUser?.role === "Admin" || 
      loggedInUser?.role === "director"
    ) {
      console.log("✅ ADMIN BUTTON ACCESS");
      return;
    }
    if (!permissions.includes(binding.value)) {
      el.style.display = "none";
    }
  },
};
